<template>
  <admin-profile
    :user="profile"
    :loading="loading"
    :readonly="!useFeature('modify_profile_details')"
    @manageClients="manageClients"
    @viewUserAccount="viewUserAccount"
    @edited="onEdited"
    @change-avatar="changeAvatar"
    @delete-avatar="deleteAvatar"
    @cancel-selection="cacelAvatarSelection"
    @sign-in-as="signInAs"
  />
</template>

<script>
import { EventBus } from '@/event-bus';
import { userService } from '@/_services';
import AdminProfile from './AdminProfile';

export default {
  components: {
    AdminProfile,
  },
  computed: {
    profile() {
      return this.$store.state.profiles.item;
    },
    loading() {
      return this.$store.state.profiles.itemStatsLoading;
    },
  },
  methods: {
    manageClients() {
      console.log('do something');
    },
    viewUserAccount() {
      console.log('do something');
    },
    onEdited(newval) {
      // Patch user data
      const payload = {
        user: {
          first_name: newval.first_name,
          last_name: newval.last_name,
          email: newval.email,
        },
        location: newval.location,
        phone_number: newval.phone,
        pk: this.profile.pk,
        whatsapp: newval.whatsapp,
        imessage: newval.imessage,
      };
      this.$store.dispatch('profiles/patchItem', payload).catch((e) => {
        const detail = e.detail ? `: ${e.detail}` : '.';
        EventBus.$emit('toast-error', `Could not update profile${detail}`);
      });
    },
    cacelAvatarSelection() {
      EventBus.$emit('avatar-editor--close');
    },
    changeAvatar(image) {
      EventBus.$emit('avatar-editor--close');
      this.$store.dispatch('profiles/patchProfileImage', {
        id: this.profile.pk,
        image,
      });
    },
    deleteAvatar() {
      // EventBus.$emit('avatar-editor--close');
      this.$store.dispatch('profiles/deleteProfileImage', {
        id: this.profile.pk,
      });
    },
    signInAs() {
      const stylistName = this.profile.user.first_name;
      const { pk } = this.profile;

      EventBus.$emit('confirm', {
        title: 'Confirmation',
        message: `
          Are you sure you want to sign out of your account and sign in as 
          <span class="confirm-stylist-name text-medium">${stylistName}</span>?
          To get back to your own account, you will need to sign in again.
        `,
        positiveText: 'Confirm',
        negativeText: 'Cancel',
        callback: (confirm) => {
          if (confirm) {
            userService.getUserTokenById(pk).then((r) => {
              const { token } = r.data;
              window.location.href = `/login?viewas=${token}`;
            });
          }
        },
      });
    },
  },
};
</script>
